var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarMensajes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sidebar_mensajes",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.693,
    height: 32.693,
    viewBox: "0 0 32.693 32.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M30.52,17.579a11.4,11.4,0,0,1-1.226,5.176,11.574,11.574,0,0,1-10.353,6.4,11.4,11.4,0,0,1-5.176-1.226L6,30.519l2.588-7.765a11.4,11.4,0,0,1-1.226-5.176,11.574,11.574,0,0,1,6.4-10.353A11.4,11.4,0,0,1,18.941,6h.681a11.557,11.557,0,0,1,10.9,10.9Z",
    transform: "translate(-1.913 -1.913)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M0,0H32.693V32.693H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMensajes);
export default __webpack_public_path__ + "static/media/sidebar_mensajes.44c4a40616f75b12e4377e9885dd7b72.svg";
export { ForwardRef as ReactComponent };